import React, { Component, PropTypes } from "react"
import { connect } from "react-redux"
import Panel from "react-bootstrap/lib/Panel"
import SubmittedIcon from "react-icons/lib/md/bookmark-outline"
import ApprovedIcon from "react-icons/lib/md/lock"
import UnlockReqIcon from "react-icons/lib/md/lock-open"
import CancelUnlockReqIcon from "react-icons/lib/md/lock-outline"

import Loading from "components/Loading"

import FormContainer from "./form-container"
import { fetchClass, saveCache } from "./actions"

class GradeShow extends Component {
  render() {
    const { __classState, params } = this.props
    const offeringGroupID = params.offeringGroupID

    if (!__classState) {
      return <Loading />
    }

    return (
      <Panel header="Class Information">
        <FormContainer model={__classState} offeringGroupID={offeringGroupID} />
        <hr />
        <h3>Status Legend:</h3>
        <div className="row">
          <div className="col-sm-6">
            <table className="table table-condensed">
              <tbody>
                <tr>
                  <td>
                    <SubmittedIcon />
                  </td>
                  <td> Submitted (pending for approval)</td>
                </tr>
                <tr>
                  <td>
                    <ApprovedIcon />
                  </td>
                  <td>Approved by the registrar</td>
                </tr>
                <tr>
                  <td>
                    <UnlockReqIcon />
                  </td>
                  <td>Request to unlock</td>
                </tr>
                <tr>
                  <td>
                    <CancelUnlockReqIcon className="text-danger" />
                  </td>
                  <td>Cancel request to unlock</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-sm-6">
            <h4>Reminders:</h4>
            <ul>
              <li>
                For non-numeric grades (i.e. DR, NA, etc.), please include the
                RE-Exam column.
              </li>
              <li>
                Grade Correction form, download{" "}
                <a
                  href="https://drive.google.com/open?id=1xNJroCUObvecgnuc7mSRpBGz4J7SPykciBWXiHVEth8"
                  target="_blank"
                >
                  here
                </a>
              </li>
            </ul>
          </div>
          <div className="col-sm-12">
            <table className="table">
              <tbody>
                <tr>
                  <td width="5%" />
                  <td width="15%">
                    <strong>
                      <small>Excellent</small>
                    </strong>
                    <br />
                    <small>
                      1.0 - 95% - 100% <br />
                      1.1 - 94% <br />
                      1.2 - 93%
                    </small>
                  </td>
                  <td width="15%">
                    <strong>
                      <small>Very Satisfactory</small>
                    </strong>
                    <br />
                    <small>
                      1.3 - 92% <br />
                      1.4 - 91% <br />
                      1.5 - 90%
                    </small>
                  </td>
                  <td width="15%">
                    <strong>
                      <small>Satisfactory</small>
                    </strong>
                    <br />
                    <small>
                      1.6 - 89% <br />
                      1.7 - 88% <br />
                      1.8 - 87% <br />
                      1.9 - 86% <br />
                      2.0 - 85%
                    </small>
                  </td>
                  <td width="15%">
                    <strong>
                      <small>Fair</small>
                    </strong>
                    <br />
                    <small>
                      2.1 - 84% <br />
                      2.2 - 83% <br />
                      2.3 - 82% <br />
                      2.4 - 81% <br />
                      2.5 - 80%
                    </small>
                  </td>
                  <td width="15%">
                    <strong>
                      <small>Good</small>
                    </strong>
                    <br />
                    <small>
                      2.6 - 79% <br />
                      2.7 - 78% <br />
                      2.8 - 77% <br />
                      2.9 - 76% <br />
                      3.0 - 75%
                    </small>
                  </td>
                  <td width="15%">
                    <strong>
                      <small>Failed</small>
                    </strong>
                    <br />
                    <small>
                      4.1 - 5.0<br />
                      WD - Withdrawn<br />
                      DR - Dropped<br />
                      NG - No Grade<br />
                      NA - Never Attended<br />
                      NC - No Credit
                    </small>
                  </td>
                  <td width="5%" />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Panel>
    )
  }
}

GradeShow.onEnter = store => nextState =>
  store.dispatch(fetchClass(nextState.params.offeringGroupID))

GradeShow.onLeave = store => nextState => {
  // save state to cache
  store.dispatch(
    saveCache(nextState.params.offeringGroupID, store.getState().classState)
  )
}

GradeShow.propTypes = {
  __classState: PropTypes.object,
  params: PropTypes.object,
}

function mapStateToProps(state, ownProps) {
  return {
    __classState: state.grade.getIn(["cache", ownProps.params.offeringGroupID]),
  }
}

export default connect(mapStateToProps)(GradeShow)



// WEBPACK FOOTER //
// ./src/containers/Grades/show.js